// PostHog removed — these are no-op stubs preserved so existing call sites
// (track / identifyUser / initAnalytics / resetAnalytics) keep compiling.
// If product analytics become important again, wire a backend logging endpoint
// or a different SDK behind this same surface area.

export function initAnalytics(): void {
  // no-op
}

export function identifyUser(_userId: number, _props?: Record<string, unknown>): void {
  // no-op
}

export function track(_event: string, _props?: Record<string, unknown>): void {
  // no-op
}

export function resetAnalytics(): void {
  // no-op
}
